import gql from 'graphql-tag'
import useSessionStorageState from '@hooks/useSessionStorageState'
import {useApolloQuery} from '@packages/apollo-hooks'
import {
  getUserOrderGroup,
  getUserOrderGroupVariables
} from '@page-components/Order/Cart/Content/__generated__/getUserOrderGroup'

export default function useUserOrderGroup({website, storeId, preferences}) {
  const [orderGroupId, setOrderGroupId] = useSessionStorageState('orderGroupId', null)

  const {userOrderGroup} = useApolloQuery<getUserOrderGroupVariables, getUserOrderGroup>({
    omit: !website || !storeId || !preferences.tableName,
    query: gql`
      query getUserOrderGroup($websiteId: ID, $storeId: ID, $tableName: String) {
        userOrderGroup(websiteId: $websiteId, storeId: $storeId, tableName: $tableName) {
          _id
          tableTotal
          ordersGroupedByUser {
            total
            count
            user {
              profile {
                firstName
              }
            }
            orders {
              _id
              code
              items {
                _id
                amount
                unitPrice
                product {
                  _id
                  name
                  images {
                    _id
                    resizedURL
                  }
                }
              }
              bagAmount
              storeId
              deliveryType
              deliveryFee
              menuId
              itemsPrice
              totalPrice
              amountToPay
              statusLabel
              orderStatus
              paymentStatus
              paidStatus
              createdAt
              isTableOrderV2
              payInTable
            }
          }
        }
      }
    `,
    variables: {websiteId: website._id, storeId, tableName: preferences.tableName}
  })

  if (!orderGroupId && userOrderGroup && userOrderGroup._id) {
    setOrderGroupId(userOrderGroup._id)
  }

  return userOrderGroup
}
